module.exports = __webpack_public_path__ + "media/images/auth-ec0b3c3a01137b2e8d3b8bb7bc4dc5c8.svg";